import React, { Component } from 'react'
import { withFirebase } from '../../config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Confirm } from 'semantic-ui-react'
import { Redirect } from 'react-router-dom';

/*Redux */
import 'firebase/firestore'
import 'firebase/auth'
import { connect } from 'react-redux'
import propTypes from 'prop-types'
/*Actions */
import {
    deleteSongParent,
    fetchAllSongParent,
    emptyError
} from '../../Actions/SongParentAction'
import { ALL_SONG_PARENTS } from '../../routes';


class DeleteSongParent extends Component {

    state = { open: false }

    open = () => this.setState({ open: true })
    close = () => this.setState({ open: false })


    deleteSongParent(id) {
        this.props.deleteSongParent(id);
    }


    handleSubmit = (e) => {

        const { id } = this.props;

        console.log("id = " + id)

        this.deleteSongParent(id);
        this.close();

    }


    render() {
        const { error } = this.props;
        const { success } = this.props;

        if (success === false) {
            alert("error missing data or network " + error)
            this.props.emptyError();

        }
        else if (success === true) {
            alert("Parent Song Deleted Successfully")
            this.props.emptyError();
            this.props.fetchAllSongParent();
            return (<Redirect to={ALL_SONG_PARENTS}></Redirect>)
        }

        return (
            <div >
                <button className="seriesCardButtons" onClick={this.open}>
                    <i>
                        <FontAwesomeIcon icon="trash-alt" />
                    </i>
                </button>
                <Confirm id="modal"
                    content='Are you sure you want to delete this Parent Song ??'
                    open={this.state.open} onCancel={this.close} onConfirm={this.handleSubmit} />
            </div>

        )
    }
}


DeleteSongParent.propTypes = {
    deleteSongParent: propTypes.func.isRequired,

}
const mapStateToProps = state => ({
    error: state.songParent.deleting_song_parent_error,
    success: state.songParent.deleting_song_parent_sucessfully
});

export default withFirebase(
    connect
        (mapStateToProps,
            {
                fetchAllSongParent,
                deleteSongParent,
                emptyError
            })
        (DeleteSongParent));
